/* file description */

import type { UseSearchProp } from './type';

export const useSearchProp: UseSearchProp = ({ search }) => {
  return (
    search ?? {
      labelWidth: 'auto',
    }
  );
};
